import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

import { cn } from '@ui/lib/utils'

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'group peer inline-flex h-xs w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 focus-visible:ring-offset-white data-[state=checked]:bg-blue-500 data-[state=unchecked]:bg-gray-200',
      'disabled:cursor-not-allowed disabled:!bg-gray-100 md:enabled:hover:data-[state=checked]:bg-blue-600 md:enabled:hover:data-[state=unchecked]:!bg-gray-300',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block size-xxs rounded-full bg-white shadow-lg ring-0 transition-[transform,width] data-[state=checked]:translate-x-[20px] data-[state=unchecked]:translate-x-0',
        {
          'md:group-hover:w-[26px] md:group-hover:data-[state=checked]:translate-x-[14px]':
            !props.disabled,
          'bg-gray-300': props.disabled,
        },
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
